import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'wm-workflow-janus-status-pill',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './workflow-janus-status-pill.component.html',
  styleUrls: ['./workflow-janus-status-pill.component.scss']
})
export class WorkflowJanusStatusPillComponent {
  @Input() row!: any;

  getStatusClass(status: string): string {
    switch ((status || '').trim().toLowerCase()) {
      case 'publish':
        return 'published';

      case 'changes available':
        return 'changes-available';

      case 'never published':
        return 'never-published';

      case 'errors':
        return 'errors';

      case 'disabled':
        return 'changes-available';

      default:
        return 'default-status';
    }
  }
}
